export default "__VITE_ASSET__FRxaeaweTxAIykdx$6Yh_w__";